export default __webpack_public_path__ + "static/media/curbPassLogoBlue.70a62e39.svg";